import React, { useState, useEffect, useRef } from 'react';
import AsyncSelect from 'react-select/async';
import MaterialTable, { MTableToolbar } from 'material-table';
import { Link, useNavigate } from 'react-router-dom';
import SlidingPane from "react-sliding-pane";
import "react-sliding-pane/dist/react-sliding-pane.css";
import ContentLoader from 'react-content-loader';
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import _ from "lodash";
import axios from 'axios';
import { ToastContainer, toast } from "react-toastify";
import authHeader from "../../services/auth-header";
import { API } from "../../backend";
import Helper from '../../Helper';
import { getTrans as t } from "../../Localization/translations";
import Billing from '../billing/index';


function CreditMemoList({ customerPermission, contractid }) {
    const CreditMemotableRef = useRef(null);
    const navigate = useNavigate();

    var customerName = "";

    const [selectedValue, setSelectedValue] = useState(null);
    const [inputvalue, setValue] = useState("");
    const [loading, setLoading] = useState(true);
    const [state1, setState] = useState({
        isPaneOpen: false,
        isPaneOpenLeft: false,
    });
    const [permissionss, setPermission] = useState(localStorage.getItem('permissions'));
    const permissionsArray = permissionss ? permissionss.split(',') : [];
    const [transactionType, setTransactionType] = useState("CreditMemo");
    const [dueInvoices, setDueInvoices] = useState([]);
    const [invoicesLoading, setInvoicesLoading] = useState(false);
    const [isApprovalRequired, setIsApprovalRequired] = useState(false);

    useEffect(() => {
        setLoading(false);
    }, []);

    useEffect(() => {
        axios.get(API + "accounting/transactiontypesview/?transaction_type=Credit Memo", { headers: authHeader() })
            .then((res) => {
                const list = res.data.data || [];
                if (list.length > 0) {
                    const approvalFlag = (list[0].approval || "").trim().toUpperCase();
                    setIsApprovalRequired(approvalFlag === "Y");
                }
            })
            .catch(() => { });
    }, []);

    useEffect(() => {
        if (CreditMemotableRef.current) {
            CreditMemotableRef.current.onQueryChange();
        }
    }, []);

    // ── Customer AsyncSelect ──────────────────────────────────────
    const handelInputChange = (value) => setValue(value);

    const handelChange = (value) => setSelectedValue(value);

    const loadOptions = async (inputValue) => {
        if (inputValue !== "") {
            const response = await axios.get(
                API + `parties/vendor/?party_type=Customer&&customer_name=${inputValue}`,
                { headers: authHeader() }
            );
            return response.data.data;
        }
    };


    // ── Due Invoice  ───────────────────────────────────────────
    const loadDueInvoices = async (customer) => {
        if (!customer) {
            setDueInvoices([]);
            return;
        }
        setInvoicesLoading(true);
        try {
            const res = await axios.get(
                API + `billing/invoiceswithdue/?per_page=100&page=1&search=&contractNumber=&customerName=${customer.customer_name}&contractid=undefined`,
                { headers: authHeader() }
            );
            const rows = res.data.data || res.data.results || [];
            setDueInvoices(rows);
        } catch (e) {
            console.error("Failed to load due invoices", e);
            setDueInvoices([]);
        } finally {
            setInvoicesLoading(false);
        }
    };

    // ── Filter handlers ───────────────────────────────────────────
    const handleClear = () => {
        setSelectedValue(null);
        setTransactionType("CreditMemo");
        CreditMemotableRef.current.onQueryChange();
    };

    // ── Navigation ────────────────────────────────────────────────
    const handleView = (id) => navigate("/creditmemo/view", { state: id });
    const handleEdit = (id) => navigate("/creditmemo/edit", { state: id });

    // ── Delete ────────────────────────────────────────────────────
    const handleDelete = (id, status) => {
        confirmAlert({
            title: "",
            message: "Are you sure you want to delete this credit memo?",
            buttons: [
                {
                    label: "Yes",
                    onClick: () => {
                        axios.delete(API + `creditmemo/${id}/`, { headers: authHeader() })
                            .then((response) => {
                                toast.success("Credit memo deleted successfully", {
                                    position: "top-right",
                                    autoClose: 1000,
                                    hideProgressBar: false,
                                    pauseOnHover: true,
                                    draggable: true,
                                    theme: "light",
                                });
                                setTimeout(() => {
                                    CreditMemotableRef.current?.onQueryChange();
                                }, 500);
                            })
                            .catch(() => {
                                toast.error("Failed to delete credit memo", {
                                    position: "top-right",
                                    autoClose: 1000,
                                    theme: "light",
                                });
                            });
                    },
                },
                { label: "No" },
            ],
        });
    };

    return (
        <>
            {loading === false ? (
                <div className="page-wrapper">
                    <ToastContainer />
                    <div className="content container-fluid">
                        <div className="row">
                            <div className="">
                                <div className="ms-auto my-auto mt-lg-0 mt-4">
                                    <div className="ms-auto my-auto"></div>
                                </div>
                            </div>
                        </div>

                        <div className="card-body">
                            <div className="success"></div>
                            <div className="row"></div>
                        </div>

                        {/* ── Filter Pane ─────────────────────────────── */}
                        <SlidingPane
                            className="some-custom-class"
                            overlayClassName="some-custom-overlay-class"
                            isOpen={state1.isPaneOpen}
                            title="Filter By"
                            subtitle=""
                            onRequestClose={() => setState({ isPaneOpen: false })}
                        >
                            <div className="col-xl-12">
                                <div className="form-group row">
                                    <label className="col-lg-12 col-form-label">{t("Transaction Type")}</label>
                                    <div className="col-lg-12">
                                        <select
                                            className="form-control"
                                            value={transactionType}
                                            onChange={(e) => setTransactionType(e.target.value)}
                                        >
                                            <option value="Invoice">Invoice</option>
                                            <option value="CreditMemo">Credit Memo</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-12">
                                <div className="form-group row">
                                    <label className="col-lg-12 col-form-label">{t("Customer Name")}</label>
                                    <div className="col-lg-12">
                                        <AsyncSelect
                                            defaultOptions
                                            isClearable
                                            placeholder={t("Search for Customer(% for All)")}
                                            value={selectedValue}
                                            getOptionLabel={e => e.customer_name}
                                            getOptionValue={e => e.customer_name}
                                            loadOptions={loadOptions}
                                            onInputChange={handelInputChange}
                                            onChange={handelChange}
                                        />
                                    </div>
                                </div>
                            </div>

                            

                            <div className="col-xl-12">
                                <div className="form-group row">
                                    <div className="col-lg-12 text-left" style={{ marginTop: "30px" }}>
                                        <button
                                            type="button"
                                            className="clearReceipt btn bg-gradient-secondary ms-auto mb-0"
                                            onClick={handleClear}
                                        >
                                            {t("RESET")}
                                        </button>
                                        &nbsp;&nbsp;
                                        <button
                                            type="button"
                                            className="clearReceipt btn btn-primary ms-auto mb-0"
                                            onClick={() => {
                                                if (transactionType === "Invoice") {
                                                    navigate("/billing");
                                                } else {
                                                    setState({ isPaneOpen: false });
                                                    Helper.handleSearch(CreditMemotableRef);
                                                }
                                            }}
                                        >
                                            {t("Apply")}
                                        </button>
                                        &nbsp;&nbsp;
                                    </div>
                                </div>
                            </div>
                        </SlidingPane>

                        {/* ── Table ───────────────────────────────────── */}
                        <div className="filter_invoice">
                            <div className="mb-0">
                                <div className="">
                                    <div className="p-0">
                                        {transactionType === "Invoice" ? (
                                            <Billing customerPermission={customerPermission} />
                                        ) : (
                                            <MaterialTable
                                                tableRef={CreditMemotableRef}
                                                style={{
                                                    backgroundColor: "var(--bs-table-bg)",
                                                    borderBottomWidth: "1px",
                                                    boxShadow: "inset 0 0 0 9999px var(--bs-table-accent-bg)",
                                                }}
                                                title={<h5 className="mb-0">{t("Credit Memos")}</h5>}
                                                columns={[
                                                    {
                                                        title: `${t("CM Number")}`,
                                                        field: "credit_memo_number",
                                                        headerStyle: {
                                                            verticalAlign: "inherit",
                                                            fontWeight: "bold",
                                                            textAlign: "left",
                                                        },
                                                        cellStyle: { textAlign: "left", fontSize: 12 },
                                                        render: rowData => (
                                                            <>
                                                                <div className="d-xl-none tc d-md-none d-lg-none" style={{ width: "10px" }}>
                                                                    {t("CM Number")}
                                                                </div>
                                                                <div
                                                                    className="hyperlink"
                                                                    onClick={() =>
                                                                        permissionss && permissionsArray.includes('view_invoiceheader') === true &&
                                                                        handleView(rowData.id)
                                                                    }
                                                                >
                                                                    {rowData.credit_memo_number}
                                                                </div>
                                                            </>
                                                        ),
                                                    },
                                                    {
                                                        title: `${t("Date")}`,
                                                        field: "credit_memo_date",
                                                        render: rowData => (
                                                            <>
                                                                <div className="d-xl-none tc d-md-none d-lg-none">{t("Date")}</div>
                                                                <div>{Helper.DateNormal(rowData.credit_memo_date)}</div>
                                                            </>
                                                        ),
                                                        headerStyle: {
                                                            verticalAlign: "inherit",
                                                            fontWeight: "bold",
                                                            textAlign: "left",
                                                        },
                                                        cellStyle: { textAlign: "left", fontSize: 12 },
                                                    },
                                                    {
                                                        title: `${t("Customer Name")}`,
                                                        field: "customer_name",
                                                        render: rowData => (
                                                            <>
                                                                <div className="d-xl-none tc d-md-none d-lg-none">{t("Customer Name")}</div>
                                                                <div>{rowData.customer_name || "-"}</div>
                                                            </>
                                                        ),
                                                        headerStyle: {
                                                            verticalAlign: "inherit",
                                                            fontWeight: "bold",
                                                            textAlign: "left",
                                                        },
                                                        cellStyle: { textAlign: "left", fontSize: 12 },
                                                    },
                                                    {
                                                        title: `${t("Amount")}`,
                                                        field: "amount",
                                                        render: rowData => (
                                                            <>
                                                                <div
                                                                    className="d-xl-none tc d-md-none d-lg-none"
                                                                    style={{ textAlign: 'left', fontSize: '12px' }}
                                                                >
                                                                    {t("Amount")}
                                                                </div>
                                                                <div
                                                                    className="d-none d-xl-block d-lg-block"
                                                                    style={{ textAlign: 'left', fontSize: '12px' }}
                                                                >
                                                                    {Helper.Amount(rowData.amount)}
                                                                </div>
                                                            </>
                                                        ),
                                                        headerStyle: {
                                                            verticalAlign: "inherit",
                                                            fontWeight: "bold",
                                                            textAlign: "left",
                                                        },
                                                        cellStyle: { textAlign: "left", fontSize: 12 },
                                                    },
                                                    // {
                                                    //     title: `${t("Reason")}`,
                                                    //     field: "reason",
                                                    //     render: rowData => (
                                                    //         <>
                                                    //             <div className="d-xl-none tc d-md-none d-lg-none">{t("Reason")}</div>
                                                    //             <div>{rowData.reason || "-"}</div>
                                                    //         </>
                                                    //     ),
                                                    //     headerStyle: {
                                                    //         verticalAlign: "inherit",
                                                    //         fontWeight: "bold",
                                                    //         textAlign: "left",
                                                    //     },
                                                    //     cellStyle: { textAlign: "left", fontSize: 12 },
                                                    // },
                                                    {
                                                        title: `${t("Status")}`,
                                                        field: "status",
                                                        render: rowData => (
                                                            <>
                                                                <div className="d-xl-none tc d-md-none d-lg-none">{t("Status")}</div>
                                                                <div
                                                                    className={
                                                                        rowData.status === 'Final'
                                                                            ? 'badge bg-gradient-success text-xxs'
                                                                            : 'badge badge-sm bg-gradient-secondary'
                                                                    }
                                                                >
                                                                    {rowData.status}
                                                                </div>
                                                            </>
                                                        ),
                                                        headerStyle: {
                                                            verticalAlign: "inherit",
                                                            fontWeight: "bold",
                                                            textAlign: "left",
                                                        },
                                                        cellStyle: { textAlign: "left", fontSize: 12 },
                                                    },
                                                    ...(isApprovalRequired ? [{
                                                        title: `${t("Approval Status")}`,
                                                        field: "approval_status",
                                                        render: rowData => (
                                                            <>
                                                                <div className="d-xl-none tc d-md-none d-lg-none">{t("Approval Status")}</div>
                                                                <div
                                                                    className={
                                                                        rowData.approval_status === 'Approved'
                                                                            ? 'badge bg-gradient-success text-xxs'
                                                                            : rowData.approval_status === 'Rejected'
                                                                                ? 'badge badge-sm bg-gradient-danger'
                                                                                : rowData.approval_status === 'Pending'
                                                                                    ? 'badge badge-sm bg-gradient-warning'
                                                                                    : 'badge badge-sm bg-gradient-secondary'
                                                                    }
                                                                >
                                                                    {rowData.approval_status}
                                                                </div>
                                                            </>
                                                        ),
                                                        headerStyle: {
                                                            verticalAlign: "inherit",
                                                            fontWeight: "bold",
                                                            textAlign: "left",
                                                        },
                                                        cellStyle: { textAlign: "left", fontSize: 12 },
                                                    }] : []),
                                                ]}
                                                data={query =>
                                                    new Promise((resolve, reject) => {
                                                        const { orderBy, orderDirection } = query;

                                                        if (selectedValue) {
                                                            customerName = selectedValue.customer_name;
                                                        }

                                                        let url = API + "creditmemo/?";
                                                        url += 'per_page=' + query.pageSize;
                                                        url += '&page=' + (query.page + 1);
                                                        url += '&search=' + query.search;
                                                        url += `&customer_name=${customerName !== "" ? customerName : ""}`;
                                                   

                                                        if (orderBy) {
                                                            url += `&orderBy=${orderBy.field}`;
                                                            url += `&orderDirection=${orderDirection}`;
                                                        }

                                                        fetch(url, { headers: authHeader() })
                                                            .then(response => response.json())
                                                            .then(result => {
                                                                const rows = result.results || result.data || [];
                                                                resolve({
                                                                    data: query.orderBy && query.orderDirection
                                                                        ? _.orderBy(rows, [query.orderBy.field], [query.orderDirection])
                                                                        : rows,
                                                                    page: query.page,
                                                                    totalCount: result.count || result.total || 0,
                                                                });
                                                            })
                                                            .catch(reject);
                                                    })
                                                }
                                                actions={
                                                    permissionss && permissionsArray.includes('delete_creditmemo') === true
                                                        ? [
                                                            // EDIT — visible only for Draft
                                                            (rowData) => ({
                                                                icon: () => (
                                                                    <img
                                                                        src={process.env.PUBLIC_URL + "/static/images/ic-edit.svg"}
                                                                        alt="edit"
                                                                        style={{
                                                                            visibility: rowData.status === "Draft" ? "visible" : "hidden",
                                                                        }}
                                                                    />
                                                                ),
                                                                tooltip: "Edit",
                                                                onClick: (event, rowData) => {
                                                                    if (rowData.status === "Draft") {
                                                                        handleEdit(rowData.id);
                                                                    }
                                                                },
                                                                disabled: rowData.status !== "Draft",
                                                            }),

                                                            // DELETE — Draft only
                                                            (rowData) => ({
                                                                icon: () => (
                                                                    <img
                                                                        src={
                                                                            rowData.status === "Draft"
                                                                                ? process.env.PUBLIC_URL + "/static/images/ic-delete.svg"
                                                                                : process.env.PUBLIC_URL + "/static/images/ic-grey-delete.svg"
                                                                        }
                                                                        alt="delete"
                                                                    />
                                                                ),
                                                                tooltip: "Delete",
                                                                onClick: (event, rowData) => {
                                                                    if (rowData.status === "Draft") {
                                                                        handleDelete(rowData.id, rowData.status);
                                                                    }
                                                                },
                                                                disabled: rowData.status !== "Draft",
                                                            }),
                                                        ]
                                                        : []
                                                }
                                                components={{
                                                    Toolbar: props => (
                                                        <div className='MuiToolbar-root MTableToolbar-spacer-21 my-temp-class'>
                                                            <MTableToolbar {...props} />
                                                            <span
                                                                onClick={() => setState({ isPaneOpen: true })}
                                                                style={{ color: "#b4b7c5", paddingRight: "1px", cursor: "pointer" }}
                                                            >
                                                                <img
                                                                    src={process.env.PUBLIC_URL + '/static/images/ic-filter.svg'}
                                                                    alt="filter"
                                                                />
                                                            </span>
                                                            {
                                                                permissionss && permissionsArray.includes('add_invoiceheader') === true ?
                                                                    customerPermission !== 'Customer' &&
                                                                    <Link className="navbar-brand m-0" to="/creditmemo/add" >
                                                                        <button className="add-part btn btn-primary  mb-0" id="add-task" >+&nbsp; {t('New Credit Memo')}</button>
                                                                    </Link>
                                                                    : null
                                                            }
                                                        </div>
                                                    ),
                                                }}
                                                options={{
                                                    headerStyle: {
                                                        backgroundColor: "white",
                                                        color: "#245C7F",
                                                        fontSize: 11,
                                                    },
                                                    rowStyle: (rowData, index) => {
                                                        if (index % 2) {
                                                            return { backgroundColor: "#fff" };
                                                        }
                                                    },
                                                    sorting: true,
                                                    search: true,
                                                    toolbar: true,
                                                    paging: true,
                                                    pageSize: 10,
                                                    emptyRowsWhenPaging: false,
                                                    pageSizeOptions: [10, 20, 25, 50],
                                                    paginationType: "stepped",
                                                    showFirstLastPageButtons: false,
                                                    actionsColumnIndex: -1,
                                                }}
                                            />
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                <ContentLoader
                    viewBox="0 0 1000 550"
                    backgroundColor="rgba(0,0,0,0.06)"
                    foregroundColor="rgba(0,0,0,0.12)"
                >
                    <rect x="51" y="45" rx="3" ry="3" width="906" height="17" />
                    <circle cx="879" cy="123" r="11" />
                    <circle cx="914" cy="123" r="11" />
                    <rect x="104" y="115" rx="3" ry="3" width="141" height="15" />
                    <rect x="305" y="114" rx="3" ry="3" width="299" height="15" />
                    <rect x="661" y="114" rx="3" ry="3" width="141" height="15" />
                    <rect x="55" y="155" rx="3" ry="3" width="897" height="2" />
                    <circle cx="880" cy="184" r="11" />
                    <circle cx="915" cy="184" r="11" />
                    <rect x="105" y="176" rx="3" ry="3" width="141" height="15" />
                    <rect x="306" y="175" rx="3" ry="3" width="299" height="15" />
                    <rect x="662" y="175" rx="3" ry="3" width="141" height="15" />
                    <rect x="56" y="216" rx="3" ry="3" width="897" height="2" />
                    <circle cx="881" cy="242" r="11" />
                    <circle cx="916" cy="242" r="11" />
                    <rect x="106" y="234" rx="3" ry="3" width="141" height="15" />
                    <rect x="307" y="233" rx="3" ry="3" width="299" height="15" />
                    <rect x="663" y="233" rx="3" ry="3" width="141" height="15" />
                    <rect x="57" y="274" rx="3" ry="3" width="897" height="2" />
                    <circle cx="882" cy="303" r="11" />
                    <circle cx="917" cy="303" r="11" />
                    <rect x="107" y="295" rx="3" ry="3" width="141" height="15" />
                    <rect x="308" y="294" rx="3" ry="3" width="299" height="15" />
                    <rect x="664" y="294" rx="3" ry="3" width="141" height="15" />
                    <rect x="58" y="335" rx="3" ry="3" width="897" height="2" />
                    <circle cx="881" cy="363" r="11" />
                    <circle cx="916" cy="363" r="11" />
                    <rect x="106" y="355" rx="3" ry="3" width="141" height="15" />
                    <rect x="307" y="354" rx="3" ry="3" width="299" height="15" />
                    <rect x="663" y="354" rx="3" ry="3" width="141" height="15" />
                    <rect x="57" y="395" rx="3" ry="3" width="897" height="2" />
                    <circle cx="882" cy="424" r="11" />
                    <circle cx="917" cy="424" r="11" />
                    <rect x="107" y="416" rx="3" ry="3" width="141" height="15" />
                    <rect x="308" y="415" rx="3" ry="3" width="299" height="15" />
                    <rect x="664" y="415" rx="3" ry="3" width="141" height="15" />
                    <rect x="55" y="453" rx="3" ry="3" width="897" height="2" />
                    <rect x="51" y="49" rx="3" ry="3" width="2" height="465" />
                    <rect x="955" y="49" rx="3" ry="3" width="2" height="465" />
                    <circle cx="882" cy="484" r="11" />
                    <circle cx="917" cy="484" r="11" />
                    <rect x="107" y="476" rx="3" ry="3" width="141" height="15" />
                    <rect x="308" y="475" rx="3" ry="3" width="299" height="15" />
                    <rect x="664" y="475" rx="3" ry="3" width="141" height="15" />
                    <rect x="55" y="513" rx="3" ry="3" width="897" height="2" />
                    <rect x="52" y="80" rx="3" ry="3" width="906" height="17" />
                    <rect x="53" y="57" rx="3" ry="3" width="68" height="33" />
                    <rect x="222" y="54" rx="3" ry="3" width="149" height="33" />
                    <rect x="544" y="55" rx="3" ry="3" width="137" height="33" />
                    <rect x="782" y="56" rx="3" ry="3" width="72" height="33" />
                    <rect x="933" y="54" rx="3" ry="3" width="24" height="33" />
                </ContentLoader>
            )}
        </>
    );
}

export default CreditMemoList;